import { Link } from "react-router-dom";
import React, { useCallback, useEffect, useState } from "react";
import BuddibleSocket from "../../../lib/BuddibleSocket";
import Utilities from "../../../lib/Utilities";
import { useTranslation } from "react-i18next";

const socket = new BuddibleSocket();
const util = new Utilities();

let video_list = [];
let backup_count = 8;
export default function FreiscopVideos() {
  const [isNeedUpdate, setIsNeedUpdate] = useState(false);
  const [colCount, setColCount] = useState(8);
  const { t } = useTranslation();

  useEffect(() => {
    SELECT_AD_VIDEO_LIST();
    resizeColumnChange();
    window.addEventListener("resize", resizeColumnChange);
    return () => {
      window.removeEventListener("resize", resizeColumnChange);
    };
  }, []);

  function resizeColumnChange() {
    let windowWidth = window.innerWidth;
    let count;
    if (windowWidth <= 576) {
      count = 4;
    } else if (windowWidth > 576) {
      count = 6;
    }
    if (backup_count !== count) {
      backup_count = count;
      setColCount(count);
    }
  }

  function SELECT_AD_VIDEO_LIST(filter) {
    let msgID = util.makeUUIDv4();
    let socketMsg = {
      file: "/advertise_video/JS_advertise_video_customer_select.php",
      msgID: msgID,
      data: {},
      ...filter,
    };
    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData["ret"]) {
          video_list = newData["returnData"];
          setIsNeedUpdate(!isNeedUpdate);
        }
      }
    });
  }

  const VideoItemRender = useCallback(({ item }) => {
    return (
      <VideoItem
        vmLink={item.vmLink}
        vmTopYN={item.vmTopYN}
        vmTitle={item.vmTitle}
        COMP_NM={item.COMP_NM}
        COMP_LOGO={item.COMP_LOGO}
      />
    );
  }, []);
  return (
    <div className="py-5">
      <div className="container margin_30">
        <div className="row m-0">
          <div className="col-12 text-center mb-5">
            <div className="h4 font-weight-bold mb-2">
              {t("main.freiscopVideos.title")}
            </div>
            <div className="text-secondary">
              {t("main.freiscopVideos.description")}
            </div>
          </div>

          <div className="col-12 m-0 p-0">
            <div className="row m-0 p-0">
              {video_list.length ? (
                video_list.slice(0, colCount).map((item, index) => {
                  return <VideoItemRender key={index} item={item} />;
                })
              ) : (
                <div className="px-md-5 col">
                  <div className="mx-5 py-5 bg-light rounded h6 font-weight-bold text-secondary text-center mb-0">
                    {t("main.freiscopVideos.msg.emptyVideo")}
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="col-12 text-center mt-sm-5">
            <Link
              to="/AdvertiseVideoCenter"
              className="text-secondary h6  hover_point cursor_pointer_fw_bold transition-2"
            >
              {t("main.freiscopVideos.viewMore")}{" "}
              <i className="fa-solid fa-arrow-right" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

const VideoItem = React.memo((props) => {
  const { vmLink, vmTitle, COMP_NM, COMP_LOGO, vmTopYN } = props;
  const { t } = useTranslation();

  return (
    <div className="col-12 col-sm-4 mb-3 d-flex flex-row justify-content-center">
      <div className="w-100 position-relative">
        <div
          className="position-absolute w-100 h-100 cursor_pointer"
          style={{ zIndex: 1 }}
          onClick={() => {
            window.open(vmLink, "_blank", "width=1200,height=800");
          }}
        />

        {vmTopYN === "Y" && (
          <div
            className="position-absolute border rounded px-3 bg-white font-weight-bold"
            style={{ top: 5, right: 5, fontSize: "0.9em" }}
          >
            {t("main.freiscopVideos.fix")}
          </div>
        )}
        <iframe
          className="rounded border"
          width="100%"
          height="200"
          src={vmLink + "?modestbranding=1&rel=0"}
          allowFullScreen={true}
          // title={vmTitle}
        />

        <div className="d-flex flex-row justify-content-start align-items-center mt-2">
          <div
            className="d-flex flex-row justify-content-center align-items-center rounded mr-2"
            style={{
              background: `url(${COMP_LOGO}) 50% 50% /contain no-repeat`,
              width: 50,
              height: 50,
            }}
          />
          <div className="text-secondary">
            <h6 className="mb-0 font-weight-bold">{vmTitle}</h6>
            <p>{COMP_NM}</p>
          </div>
        </div>
      </div>
    </div>
  );
});
